import type { ParcelReminderEvent, ParcelReminderState } from "../../logic/parcelReminderMachine";
import "./ParcelShowcasePanel.css";
import { ParcelSpatialDiagram, formatParcelDistance as formatDistance } from "./ParcelSpatialDiagram";
import { parcelDistance } from "../../config/parcelSpatial";

type Props = {
  model: ParcelReminderState;
  onEvent: (event: ParcelReminderEvent) => void;
};

export function ParcelShowcasePanel({ model, onEvent }: Props) {
  return (
    <aside className="parcel-showcase-panel parcel-showcase-panel--spatial" aria-label="车辆与快递演示状态">
      <ParcelSpatialDiagram model={model} onEvent={onEvent} />
      <div className="parcel-context-controls">
      <div className="parcel-context-stats">
        <div><span>距家</span><strong>{formatDistance(parcelDistance(model.vehiclePosition, "home"))}</strong></div>
        <div><span>距公司</span><strong>{formatDistance(parcelDistance(model.vehiclePosition, "company"))}</strong></div>
        <div><span>当前档位</span><strong>{model.gear}<small>{model.gear === "P" ? " 停车" : " 行驶"}</small></strong></div>
        <div><span>待取快递</span><strong>{model.pendingCount}<small> 件</small></strong></div>
      </div>
      <div className="parcel-position-presets" role="group" aria-label="车辆位置快捷操作">
        <span>快捷移车</span>
        <button type="button" onClick={() => onEvent({ type: "POSITION", position: {x: 300, y: 0} })}>家附近 300 m</button>
        <button type="button" onClick={() => onEvent({ type: "POSITION", position: {x: 2500, y: 0} })}>两个范围圈外</button>
        <button type="button" onClick={() => onEvent({ type: "POSITION", position: {x: 4700, y: 0} })}>公司附近 300 m</button>
      </div>
      <div className="parcel-gear-control" role="group" aria-label="车辆档位模拟">
        <button type="button" aria-pressed={model.gear === "D"} onClick={() => onEvent({ type: "GEAR", gear: "D" })}><strong>D</strong><span>切 D 档 · 行驶</span></button>
        <button type="button" aria-pressed={model.gear === "P"} onClick={() => onEvent({ type: "GEAR", gear: "P" })}><strong>P</strong><span>挂入 P 档 · 停车</span></button>
      </div>
      <div className={`parcel-context-message is-${model.phase}`} role="status" aria-live="polite"><span /><p>{model.message}</p></div>
      </div>
    </aside>
  );
}
